export enum PaymentMethod {
  CREDIT_CARD = 'credit-card',
  PIX = 'pix',
  /** @deprecated */
  BANKSLIP = 'bankslip',
  /**
   *  @description
   *  esse formato é o que o back retorna e que iremos adotar como novo padrão, no momento
   *  não faz sentido remover o formato antigo por ser usado no fluxo direto, mas iremos remover de forma gradativa
   */
  BANK_SLIP = 'bank-slip',
  DEFAULT_CREDIT_CARD = 'default-credit-card',
  NU_PAY = 'nu-pay',
  CREDIT_CARD_IN_PERSON = 'credit-card-in-person',
  PIX_IN_PERSON = 'pix-in-person',
  CASH = 'cash',
  CHEQUE = 'cheque',
  M_PESA = 'm-pesa',
  CREDIT_CARD_PLUS_CREDIT_CARD = 'credit-card+credit-card',
}
